export const Tenants = ["demo", "allianz", "ia-fidelity"];